import axios from "axios";

export const CreateTheoryApi = async (theory, token) => {
  try {
    const BASED_URL = process.env.REACT_APP_BASED_URL;
    const path = "/admin/theory/create?";
    const endpoint = `${BASED_URL}${path}token=${token}`;

    const response = await axios.post(endpoint, theory);

    return response;
  } catch (error) {
    return error.response;
  }
};

export default CreateTheoryApi;
